/**
 * Carbon Compactors — contact form guard
 *
 * Enforces the `contact[cc_hp]` honeypot rendered by snippets/cc-form-meta.liquid.
 *
 * WHY THE FIELD IS NOT CALLED "website" ANY MORE
 * It used to be `contact[website]`. Chrome's autofill ignores autocomplete="off",
 * recognised "website", and filled in the visitor's company URL — so this guard
 * silently threw away a real quote request (2026-09-22, PDP quote form). The name
 * is now meaningless to autofill heuristics, and a trap that the BROWSER filled
 * (:autofill) is treated as a human, cleared, and let through.
 *
 * Deliberately standalone rather than folded into cc-posthog-events.js — spam
 * filtering must keep working when an ad blocker prevents analytics from loading.
 * Every block is still reported to PostHog (form_trap_blocked) when it is loaded,
 * so a false positive can never be invisible again.
 *
 * Schema: ops/form-schema.md (ecomm repo)
 */
(function () {
  'use strict';

  var TRAP = 'input[name="contact[cc_hp]"]';

  function autofilled(el) {
    try { if (el.matches(':autofill')) return true; } catch (_) {}
    try { if (el.matches(':-webkit-autofill')) return true; } catch (_) {}
    return false;
  }

  // true = reject. A trap filled by the browser's autofill belongs to a person.
  function isTrap(form) {
    var hp = form.querySelector(TRAP);
    if (!hp || !hp.value || hp.value.trim() === '') return false;
    if (autofilled(hp)) {
      hp.value = '';
      return false;
    }
    return true;
  }

  function report(form) {
    try {
      if (window.posthog && window.posthog.capture) {
        window.posthog.capture('form_trap_blocked', {
          form_id: form.id || null,
          form_page: window.location.pathname
        }, { send_instantly: true });
      }
    } catch (_) {}
  }

  function wire(form) {
    if (form.dataset.ccGuardWired === '1') return;
    form.dataset.ccGuardWired = '1';
    // Capture phase so we run before any other submit handler (including the
    // PostHog capture) and can stop the event reaching them.
    form.addEventListener(
      'submit',
      function (e) {
        if (!isTrap(form)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        report(form);
        // Fail silently — never tell a bot why it was rejected.
        try {
          form.reset();
        } catch (_) {}
      },
      true
    );
  }

  function wireAll() {
    var traps = document.querySelectorAll(TRAP);
    for (var i = 0; i < traps.length; i++) {
      var form = traps[i].form || traps[i].closest('form');
      if (form) wire(form);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wireAll);
  } else {
    wireAll();
  }

  // Forms injected after load (e.g. the popup, if re-enabled) still get guarded.
  // Coalesced to one pass per frame — a bare observer would re-run the whole
  // querySelectorAll on every DOM mutation, and Shopify mutates constantly
  // (cart drawer, section rendering, lazy images).
  if (window.MutationObserver) {
    try {
      var queued = false;
      new MutationObserver(function () {
        if (queued) return;
        queued = true;
        var run = function () {
          queued = false;
          wireAll();
        };
        if (window.requestAnimationFrame) {
          window.requestAnimationFrame(run);
        } else {
          setTimeout(run, 100);
        }
      }).observe(document.body || document.documentElement, {
        childList: true,
        subtree: true
      });
    } catch (_) {}
  }
})();
